import { Card, CardContent } from '@material-ui/core';
import React from 'react';
import { layoutLoginStyles } from './Styles';

const LayoutLogin = ({ logoImg, logoTitulo, cardContent }) => {
  const styles = layoutLoginStyles();

  return (
    <>
      <div className={styles.leftContentContainer}>
        <div className={styles.leftContent}>
          <div>{logoImg}</div>
          <div>{logoTitulo}</div>
        </div>

        <Card className={styles.card}>
          <CardContent className={styles.cardContent}>{cardContent}</CardContent>
        </Card>
      </div>
    </>
  );
};

export default LayoutLogin;
